function formatDate(date) {
  const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date)
  const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date)

  return `${ye}-${mo}` // yyy-mm
}

export default formatDate
